import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Introduction() {
    return (
        <OnboardingBody title='Introducing Scheduler: Simplify your meeting scheduling'>
            <p>Scheduler is an integrated tool designed to simplify meeting scheduling.</p>
            <p>
                Effortlessly manage your availability and empower others to book meetings with you
                directly through Nutshell. Streamline your scheduling process, save valuable time,
                and stay organized.
            </p>
            <p>To begin, you’ll need to connect your Google or Office 365 calendar.</p>
        </OnboardingBody>
    );
}
